import React from "react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../contexts/LanguageContext";
import "./css/GallerySection.css";

import desktopgallery from "../media/desktopgallery.png";
import phonegallery from "../media/phonegalley.png";

export default function PaintingGallery() {
  const navigate = useNavigate();
  const { t } = useLanguage();

  const handleClick = (e) => {
    e.preventDefault();
    navigate("/paintings");
  };

  return (
    <section className="gallery-section" id="gallery">
      <h2 className="gallery-section-title">{t("gallery.title")}</h2>
      <a
        href="/paintings"
        onClick={handleClick}
        className="gallery-image-link"
        aria-label="Navigate to Paintings"
      >
        <img
          className="gallery-image desktop-gallery"
          src={desktopgallery}
          alt={t("gallery.imageAlt")}
        />
      </a>
      <a
        href="/paintings"
        onClick={handleClick}
        className="gallery-image-link"
        aria-label="Navigate to Paintings"
      >
        <img
          className="gallery-image phone-gallery"
          src={phonegallery}
          alt={t("gallery.imageAlt")}
        />
      </a>
    </section>
  );
}
